import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';
import './ReportCustomerView.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const StatCard = ({ label, value, sub }) => (
  <div className="rcv-stat-card">
    <div className="rcv-stat-label">{label}</div>
    <div className="rcv-stat-value">{value ?? '—'}</div>
    {sub && <div className="rcv-stat-sub">{sub}</div>}
  </div>
);

const ReportCustomerView = () => {
  const { user } = useContext(AuthContext);
  const authHeader = { Authorization: `Bearer ${user?.token}` };

  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/reports/customer-view`, { headers: authHeader })
      .then((res) => setData(res.data))
      .catch((err) => setError(err.response?.status === 403 ? 'Access denied.' : 'Failed to load report.'))
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <div className="rcv-loading">Loading…</div>;
  if (error)   return <div className="rcv-error">{error}</div>;

  const s = data.summary;

  return (
    <div className="rcv-container">
      <h2 className="rcv-title">Reports — Customer View</h2>

      <div className="rcv-stats-grid">
        <StatCard label="Total Registered" value={s.total_registered} />
        <StatCard label="No Sales Ever"    value={s.no_sales} />
        <StatCard label="At Least 1 Sale"  value={s.at_least_one_sale} />
        <StatCard label="Active — Last 7 Days"  value={s.active_7d}
          sub={`of ${s.active_30d} active in 30 days`} />
        <StatCard label="Active — Last 30 Days" value={s.active_30d} />
        <StatCard label="Lapsed"           value={s.lapsed}
          sub="ordered before, none in 30 days" />
      </div>

      <h3 className="rcv-section-title">Top 25 Customers — Last 30 Days</h3>

      <div className="rcv-table-wrap">
        <table className="rcv-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Customer</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>Orders</th>
              <th>Amount (₹)</th>
            </tr>
          </thead>
          <tbody>
            {data.top25.length === 0 ? (
              <tr>
                <td colSpan={6} className="rcv-empty">No orders in the last 30 days</td>
              </tr>
            ) : (
              data.top25.map((row, i) => (
                <tr key={i}>
                  <td className="rcv-rank">{i + 1}</td>
                  <td>{row.customer_name}</td>
                  <td>{row.mobile}</td>
                  <td>{row.email}</td>
                  <td className="rcv-num">{row.order_count}</td>
                  <td className="rcv-num">₹{Number(row.total_amount).toLocaleString('en-IN')}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportCustomerView;
